/* eslint-disable camelcase */

import { toJS, observable, computed, override, makeObservable } from 'mobx'
import Role from './Role'
import Model from './Model'

class User extends Model {
  @observable id = 0
  @observable role_id = 2
  @observable role = null
  @observable isClient = false
  @observable equipments = {
    _ids: []
  }

  @observable first_name = ''
  @observable last_name = ''
  @observable title = ''
  @observable code = ''
  @observable serial_number = ''
  @observable certificate_number = ''
  @observable password = ''
  @observable mobile = ''
  @observable email = ''
  @observable status = ''
  @observable created = ''
  @observable modified = ''

  _fieldToSave = [
    'equipments',
    'role_id',
    'first_name',
    'last_name',
    'title',
    'code',
    'mobile',
    'email',
    'password',
    'serial_number',
    'certificate_number'
  ]

  @computed
  get fullName () {
    return `${this.first_name} ${this.last_name}`
  }

  constructor () {
    super()
    makeObservable(this)
  }

  @override
  setData (data) {
    const { role, equipments, ...rest } = data
    if (role) {
      if (typeof role !== 'string') {
        this.role = new Role(role)
      } else {
        this.role = role
      }
    }
    if (Array.isArray(equipments)) {
      for (const equipment of equipments) {
        this.equipments._ids.push(equipment.id)
      }
    }
    super.setData(rest)
  }

  toJson () {
    const user = {}
    for (const props of this._fieldToSave) {
      user[props] = toJS(this[props])
    }
    return user
  }
}

export default User
